"use strict";
var arraySpeciesConstructor = require("../internals/array-species-constructor");
module.exports = function(originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};
